import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../general/general.module').then(m => m.GeneralModule),
      },
      {
        path: 'b2c',
        loadChildren: () => import('../b2c/b2c.module').then(m => m.B2cModule),
      },
      {
        path: 'b2bselling',
        loadChildren: () => import('../b2b/b2b.module').then(m => m.B2bModule),
      },
      {
        path: 'business-buying',
        loadChildren: () => import('../business-buying/business-buying.module').then(m => m.BusinessBuyingModule),
      },
      {
        path: 'support',
        loadChildren: () => import('../support/support.module').then(m => m.SupportModule),
      },
      {
        path: 'donations',
        loadChildren: () => import('../donations/donations.module').then(m => m.DonationsModule),
      },
      {
        path: 'working-capital',
        loadChildren: () => import('../b2b-capital/b2b-capital.module').then(m => m.B2BCapitalModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'support',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
